/*============================================================================
  BYOB discount-code sync — theme.BYOBDiscountSync
  Loaded on every page. Keeps the correct hidden BYOB tier code applied
  (via the /discount/<code> cookie) based on how many builder-added items
  (properties._byob) are in the cart, so the discount follows the shopper
  even if they edit quantities in the drawer on other pages.

  Only items added by the bundle builder count — that's the whole point:
  regular purchases never trigger the code. The codes themselves also carry
  matching minimum-quantity rules in Shopify, so a leaked code can't do more
  than the builder would.

  Tier config is written to localStorage by byob-builder.js so it always
  matches the theme-editor settings; sensible defaults otherwise.
==============================================================================*/
(function () {
  'use strict';

  var TIERS_KEY = 'theme_byob_tiers';
  var APPLIED_KEY = 'theme_byob_applied_code';
  // Overwrites the discount cookie when the cart no longer qualifies for any
  // tier. Intentionally not a real code: checkout just ignores it.
  var RESET_CODE = 'BYOB-RESET';

  var defaults = {
    thresholdType: 'quantity',
    tiers: [
      { threshold: 3, code: 'BYOB15' },
      { threshold: 5, code: 'BYOB20' },
      { threshold: 7, code: 'BYOB25' }
    ]
  };

  function getConfig() {
    try {
      var stored = JSON.parse(localStorage.getItem(TIERS_KEY));
      if (stored && stored.tiers && stored.tiers.length) return stored;
    } catch (e) { /* fall through */ }
    return defaults;
  }

  function getApplied() {
    try {
      return localStorage.getItem(APPLIED_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setApplied(code) {
    try {
      localStorage.setItem(APPLIED_KEY, code);
    } catch (e) { /* private browsing */ }
  }

  var busy = false;
  var pending = false;

  function sync() {
    if (busy) {
      pending = true;
      return Promise.resolve();
    }
    busy = true;

    var cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    return fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(applyForCart)
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          return sync();
        }
      });
  }

  function applyForCart(cart) {
    var config = getConfig();

    // Count only builder-added lines (gifts excluded).
    var count = 0;
    var subtotal = 0;
    cart.items.forEach(function (item) {
      if (!item.properties || !item.properties._byob || item.properties._byob_gift) return;
      count += item.quantity;
      subtotal += typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
    });
    var value = config.thresholdType === 'spend' ? subtotal / 100 : count;

    var code = '';
    var tiers = config.tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
    tiers.forEach(function (tier) {
      if (tier.code && value >= tier.threshold) code = tier.code;
    });

    if (!code && !getApplied()) return; // nothing applied, nothing to clear
    var target = code || RESET_CODE;
    if (target === getApplied()) return; // already in the right state

    // GET /discount/<code> sets the checkout discount cookie.
    return fetch('/discount/' + encodeURIComponent(target), { credentials: 'same-origin' })
      .then(function () { setApplied(target); })
      .catch(function () {});
  }

  window.theme = window.theme || {};
  theme.BYOBDiscountSync = { sync: sync };

  document.addEventListener('ajaxProduct:added', function () { sync(); });
  document.addEventListener('cart:updated', function () { sync(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();
